import { BallTriangle, ThreeCircles } from 'react-loader-spinner';
import styles from './Loading.module.scss';
import classNames from 'classnames/bind';
import LoadingStore from './LoadingStore';
import { useAtom } from 'jotai';

interface LoadingProps {}

const cx = classNames.bind(styles);
const Loading: React.FC<LoadingProps> = (props) => {
  const [loading, setLoading] = useAtom(LoadingStore);
  return loading ? (
    <div className={cx('wrapper')}>
      <ThreeCircles
        visible={true}
        height="100"
        width="100"
        color="#4fa94d"
        ariaLabel="three-circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  ) : null;
};

export default Loading;
